import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"light"}/>
}
